
// FIX: Removed a self-referencing import of 'MaintenanceItem' from this file.

/**
 * Represents a care facility location.
 */
export interface Facility {
  id: number;
  name: string;
  logoUrl: string;
}

/**
 * Represents a caregiver or staff member who can be assigned to tasks.
 */
export interface Caregiver {
  id: number;
  first_name: string;
  last_name: string;
  full_name: string;
  role: string;
}

/**
 * Represents a message or comment associated with a maintenance item.
 */
export interface Message {
  id: number;
  maintanance_id: number;
  message: string;
  image?: string | null;
  created_by: number;
  created_at: string;
  created_by_first_name: string;
  created_by_last_name: string;
  created_by_image_url_s3?: string | null;
}

/**
 * Represents an image attached to a maintenance item.
 */
export interface MaintenanceImage {
  id: number;
  image_name: string;
  image_prefix: string;
  image_url_s3: string;
}

/**
 * Represents a log entry for an auditable event on a maintenance item (e.g., status change).
 */
export interface AuditLog {
  id: number;
  maintanance_id: number;
  event_type: 'status_change' | 'priority_change' | 'assignee_change' | 'task_creation' | 'category_change';
  old_value: string | null;
  new_value: string | null;
  created_by_full_name: string;
  created_at: string;
}

/**
 * Represents a single maintenance task. This is the core data model for the application.
 */
export interface MaintenanceItem {
  id: number;
  order_id: number | null;
  title: string;
  description: string;
  centre_id: number;
  status: string; // Will be cast to Status enum
  priority: string | number | null; // API sends priority as a string number e.g. "1", "2"
  assigned_to: number;
  created_by: number;
  created_at: string;
  assigned_to_full_name: string | null;
  created_by_full_name: string;
  completed_by_full_name: string | null;
  completed_by: number | null;
  issues_category: string | null;
  images: MaintenanceImage[]; 
  messages?: Message[];
  history?: AuditLog[];
  /** Flag for optimistic UI updates. True if the item is being created and hasn't been confirmed by the server yet. */
  isOptimistic?: boolean;
}

/**
 * A union type representing any item that can appear in the activity feed (a message or an audit log).
 */
export type ActivityItem = Message | AuditLog;

/**
 * Enum for the possible statuses of a maintenance task.
 */
export enum Status {
  Open = 'open',
  InProgress = 'in progress',
  Completed = 'completed',
  Pending = 'pending',
}

/**
 * Enum for the possible priority levels of a maintenance task.
 */
export enum Priority {
  Critical = 'Critical',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

/**
 * Type defining the available view modes for the task dashboard.
 */
export type ViewMode = 'grid' | 'list' | 'kanban';

/**
 * Type defining the payload structure for updating a maintenance item.
 * All properties are optional.
 */
export type UpdatePayload = {
  title?: string;
  description?: string;
  status?: Status;
  priority?: Priority;
  issues_category?: string | null;
  assigned_to?: number;
};
